export default __webpack_public_path__ + "static/pdp-receive-at-home-98befffebb68f5f4150a7a5f1db9b5c1.svg";